import React, {useState, useRef, useEffect} from 'react';
import Link from "next/link";
import {useRouter} from "next/router";
import styled from "styled-components";
import {UserContext, UserDispatcherContext} from "@providers/user";
import {getDefaultCity} from "@hooks/cities";
import {isEmpty, str_replace} from "@helpers/helpers";
import RadiusGenerate from "@helpers/radius.generate";
import ConvertPixelToRem from "@helpers/convert.rem";
import Avatar from "@atoms/avatar";
import ButtonTransparent from "@atoms/button.transparent";
import Divider from "@atoms/divider";
import Icon from "@atoms/icon";
import {useWindowSize} from "@helpers/windows.size";
import {getAvatar} from "@models/user"
import ButtonBase from "@atoms/button.base";
import ChevronDownIcon from '@icons/chevron-down.svg';
import MyPropertyIcon from '@icons/menu/menu-my-property.svg';
import BookmarkIcon from '@icons/menu/menu-bookmark.svg';
import MenuUserIcon from '@icons/menu/menu-user.svg';
import ExitIcon from '@icons/menu/menu-exit.svg';
import ChevronLeftIcon from '@icons/chevron-left.svg';

function NavBarAccount({setLoginShow, className}) {
    const windowSize = useWindowSize();
    const Router = useRouter();
    const userContext = React.useContext(UserContext);
    const userDispatcherContext = React.useContext(UserDispatcherContext);

    const dropdownRef = useRef(null);
    const [accountDropdown, setAccountDropdown] = useState(false);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setAccountDropdown(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const handleLogout = () => {
        const defaultCity = getDefaultCity(true);

        userDispatcherContext({
            type: 'LOGOUT',
            payload: {},
        });

        let url = '/';
        let path = '/';
        if (!isEmpty(defaultCity)) {
            url = '/املاک-' + str_replace(' ', '-', defaultCity.name);
            path = '/properties';
        }

        if (!isEmpty(url) && process.browser) {
            Router.push(path, url);
        }
    };

    const handleShowAccountList = () => {
        if (windowSize > 991) {
            setAccountDropdown(!accountDropdown)
        } else {
            let path = '/profile';

            if (userContext.isRealtor) {
                path = '/panel'
            } else if (userContext.isAdmin) {
                path = '/admin';
            }

            Router.push(path);
        }
    };

    return (
        <Account ref={dropdownRef} className={"mb-24 mb-lg-0 " + (className ? className : '')}>
            {
                // auth() == true;
                (userContext.check) ?
                    <ul>
                        <li>
                            <UserMenu onClick={() => handleShowAccountList()} className="d-flex">
                                <Avatar src={!isEmpty(userContext.user.avatar) ? getAvatar(userContext.user.id, userContext.user.updated_at) : getAvatar()} className="ml-lg-8" size={32} lazyLoad={false}/>
                                <HandleUserName/>
                            </UserMenu>

                            <Dropdown className={(accountDropdown ? 'show' : '')}>
                                <ul>
                                    {
                                        (userContext.isRealtor) ?
                                            <li>
                                                <a href="/panel">
                                                    <span>پنل مدیریت</span>
                                                </a>
                                            </li>
                                            :
                                            (
                                                (userContext.isAdmin) ?
                                                    <li>
                                                        <a href="/admin" className="d-flex align-items-center">
                                                            <Icon className="ml-8" width={16} height={16}><MenuUserIcon/></Icon>
                                                            <span>مدیریت</span>
                                                        </a>
                                                    </li>
                                                    :
                                                    <React.Fragment>
                                                        <li>
                                                            <Link href={{
                                                                pathname: '/properties',
                                                                query: {category: 'my_properties'},
                                                            }} as="/properties?categories[my_properties]=on">
                                                                <a className="d-flex align-items-center">
                                                                    <Icon className="ml-8" width={16} height={16}><MyPropertyIcon/></Icon>
                                                                    <span>آگهی‌های من</span>
                                                                </a>
                                                            </Link>
                                                        </li>
                                                        {/* <li>
                                                            <a href="/applicants" className="d-flex align-items-center">
                                                                <Icon className="ml-8" width={16} height={16}><ApplicantIcon/></Icon>
                                                                <span>درخواست‌های من</span>
                                                            </a>
                                                        </li> */}
                                                        <li>
                                                            <Link href={{
                                                                pathname: '/properties',
                                                                query: {category: 'follow'},
                                                            }} as="/properties?follow=1">
                                                                <a className="d-flex align-items-center">
                                                                    <Icon className="ml-8" width={16} height={16}><BookmarkIcon/></Icon>
                                                                    <span>نشان‌شده‌ها</span>
                                                                </a>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link href="/users/profile/edit" as="/profile">
                                                                <a className="d-flex align-items-center">
                                                                    <Icon className="ml-8" width={16} height={16}><MyPropertyIcon width="16"/></Icon>
                                                                    <span>ویرایش پروفایل</span>
                                                                </a>
                                                            </Link>
                                                        </li>

                                                    </React.Fragment>
                                            )
                                    }

                                    <Divider className="mt-8 mb-8"/>
                                    <li className="d-none d-lg-block logout">
                                        <ButtonTransparent onClick={handleLogout} className="d-flex align-items-center">
                                            <Icon className="ml-8" width={16} height={16}><ExitIcon/></Icon>
                                            <span>خروج</span>
                                        </ButtonTransparent>
                                    </li>
                                </ul>
                            </Dropdown>

                        </li>
                    </ul>
                    :
                    <LoginBtn>
                        {
                            (process.browser && window.innerWidth < 992) ?
                                <ButtonBase color="primary" size="sm" variant="outline" onClick={() => setLoginShow(true)}>ورود یا ثبت‌نام</ButtonBase>
                                :
                                <ButtonTransparent onClick={() => setLoginShow(true)} className="text-dark">ورود یا ثبت‌نام</ButtonTransparent>
                        }
                    </LoginBtn>
            }
        </Account>
    )
}

export default NavBarAccount;

const HandleUserName = () => {
    const userContext = React.useContext(UserContext);

    return (
        <React.Fragment>
            {
                (userContext.isRealtor) ?
                    <UserName>
                        <span className="user-name">{userContext.getName}</span>
                        <span className="user-action d-flex d-lg-none">
                            ورود به پنل مدیریت
                            <Icon className="mr-8"><ChevronLeftIcon width="16"/></Icon>
                        </span>
                    </UserName>
                    :
                    (
                        (userContext.isAdmin) ?
                            <UserName>
                                <span className="user-name">{(!isEmpty(userContext.getName) ? userContext.getName : 'حساب من')}</span>
                                <div className="user-action d-flex d-lg-none">
                                    مدیریت
                                    <Icon className="mr-8"><ChevronLeftIcon width="16"/></Icon>
                                </div>
                                <Icon className="mr-4"><ChevronDownIcon/></Icon>
                            </UserName>
                            :
                            <UserName>
                                <span className="user-name">{(!isEmpty(userContext.getName) ? userContext.getName : 'حساب من')}</span>
                                <div className="user-action d-flex d-lg-none">
                                    ویرایش پروفایل
                                    <Icon className="mr-8"><ChevronLeftIcon width="16"/></Icon>
                                </div>
                                <Icon className="mr-4"><ChevronDownIcon/></Icon>
                            </UserName>
                    )

            }
        </React.Fragment>
    )
};

//styles
const Account = styled.div`
    @media (min-width: ${props => props.theme.screenSmMax}) {
        position: relative;
        margin-right: auto;
        margin-left: 24px;
    }
`;

const UserMenu = styled(ButtonTransparent)`
    align-items: center;
    @media (max-width: ${props => props.theme.screenSmMax}) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        flex-direction: row-reverse;
        width: 100%;
    
        img {
          width: 72px;
          height: 72px;
          min-width: 72px;
          max-width: 72px;
        }
    }
`;

const Dropdown = styled.div`
    display: none;
    width: 200px;
    position: absolute;
    top: 56px;
    padding: 16px 0;
    background-color: ${props => props.theme.white};
    ${RadiusGenerate('8px')};
    box-shadow: 0 10px 37px 0 rgba(0, 0, 0, 0.15);
    z-index: 37;
    
    &.show {
        display: block;
    }
    
    li {
        padding: 0;
        a,button {
            display: block;
            padding: 8px 24px;
            font-size:${props => props.theme.fontSizeBase};
            line-height: 1.8;
            color: ${props => props.theme.black};
        }
        
        &.logout {
            
            button {
                width: 100%;
                text-align: right;
                margin-top: 8px;
            }
        }
        
        &:hover {
            background-color: ${props => props.theme.gray100};
        }
    }
`;

const UserName = styled.span`
    display: flex;
    align-items: center;
    
    svg {
        width: 10px;
        height: 10px;
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
    text-align: right;
    flex-direction: column;
    align-items: flex-start;
    
    .user-name {
        font-size: ${ConvertPixelToRem(21)};
        font-weight: bold;
        line-height: 1.67;;
        color: ${props => props.theme.black};
    }
    
    .user-action {
        font-size: ${ConvertPixelToRem(16)};
        font-weight: normal;
        line-height: 1.69;
        color: ${props => props.theme.black};
    }
    
    svg {
         display: none;
    }
    
    .user-action svg {
        display: block;
        width: 6px;
    }
`;

const LoginBtn = styled.div`
    button {
        font-size: 15px;
        font-weight: 400;
        line-height: 1.69;
        
     
    }
`;